import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

/* This apiKey is safe to expose to public */
firebase.initializeApp({
  apiKey: 'AIzaSyB_ZMbnle4vc7Vh4hmYnuT8YvZBG64RCnU',
  authDomain: 'nca-dna-preference-center.firebaseapp.com',
  projectId: 'nca-dna-preference-center',
  databaseURL: "https://nca-dna-preference-center.firebaseio.com"
});

export function getFirebaseCollectionName(env) {
  return `user-pref-db-${env}`;
}

export const firebaseApp = firebase;
